// 👇 ALLE Imports korrekt
import React, { useState, useEffect, useCallback, memo } from 'react';
import {
  Box,
  Grid,
  Typography,
  IconButton,
  useMediaQuery,
  Button,
} from '@mui/material';
import { Close, Circle } from '@mui/icons-material';
import { useHistory, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Icon from 'components/Icon';
import LikeButton from 'components/LikeButton';
import MessageButton from 'components/MessageButton';
import IceBreakerButton from 'components/IceBreaker/IceBreakerButton';
import StrangerImageGallery from '../components/StrangerImageGallery';
import generateValidUrl from 'core/fetch/generateValidUrl';
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import { fetchUser } from 'models/user/fetchUser';
import { fetchPublicUser } from 'models/user/fetchPublicUser';
import useUserAndToken from 'core/useUserAndToken';
import { isError } from 'models/core/error/IError';
import AttributeChips from '../ProfilePage/components/AttributesPaper/AttributeChips';
import ChatInput from '../MessagesPage/ChatInput';
import useTranslation from 'services/i18n/core/useTranslation';
import { getAge, formatHeight } from 'models/user/IUser';
import {
  AugenMap,
  BeziehungMap,
  HaareMap,
} from 'temp/models/BerndUserTraits';
import MessageIcon from 'assets/images/icons/message.png';
import StrangerPictureComponent from './StrangerPictureComponent';
import { MESSAGES_PATH, REGISTER_USER, HOME_PATH, EXPLORER_PATH } from 'models/Paths';
import PublicAppbarComponent from 'pages/Landingpage/components/PublicAppbarComponent';
import { faCheckCircle, faLocationArrow } from '@fortawesome/pro-light-svg-icons';
import Modal from 'components/Modal';
import NewMessageDialog from './NewMessageDialog';
import ChatActionCreator from 'services/Chat/actions/ChatActionCreator';
import { useDispatch } from 'react-redux';
import { ChatMessageTypes } from 'models/chat/ChatMessageType';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';


export const StrangerProfilePage = memo(() => {
  const { strangerId, id: routeId } = useParams<{ strangerId: string; id?: string }>();
  const history = useHistory();
  const { user, token } = useUserAndToken();
  const [strangerUser, setStrangerUser] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentKey, setCurrentKey] = useState(0);
  const [messageDialogOpen, setMessageDialogOpen] = useState(false);
  const [messageLoading, setMessageLoading] = useState(false);
  const translation = useTranslation();
  const isMobile = useMediaQuery('(max-width: 600px)');
  const isDesktop = useMediaQuery('(min-width: 1000px)');
  const profileId = routeId;
  const dispatch = useDispatch();

  const handleBack = () => history.push(EXPLORER_PATH);

  const filteredPictures = (strangerUser?.Pictures || []).filter((element: { Art: number; }) => element.Art !== 2);
  const diashowPictures = filteredPictures.filter((p: any) => p.Coins === 0);

  const handleClick = (index: number) => {
    setCurrentKey(index);
    setOpenDialog(true);
  };

  const handleAboutMeClick = () => {
    setMessageDialogOpen(true);
  };

  const handleOpenMessageDialog = () => setMessageDialogOpen(true);
  const handleCloseMessageDialog = () => setMessageDialogOpen(false);
  const handleSendMessage = async (msg: string) => {
    if (!strangerUser?.Profilid || !user?.Userid) return;
    setMessageLoading(true);
    msg = "Reagiert auf dein Profil: " + msg;
    await dispatch(ChatActionCreator.sendMessage(
      strangerUser.Profilid,
      msg,
      ChatMessageTypes.MESSAGE,
      user.Userid
    ));
    setMessageLoading(false);
    setMessageDialogOpen(false);

    // Redirect to message screen after successful message send
    const chatRoute = `${MESSAGES_PATH.replace(':id?', strangerUser.Profilid)}?openChat=true`;
    history.push(chatRoute);
  };

  const fetchProfile = useCallback(() => {
    const fetchFn = user && token && profileId
      ? fetchUser.bind(null, user.Userid, profileId, token, user)
      : fetchPublicUser.bind(null, strangerId);

    fetchFn().then((res: any) => {
      if (!isError(res)) {
        setStrangerUser(res[0]);
      }
      setIsLoading(false);
    });
  }, [user, token, profileId, strangerId]);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    appendDots: (dots: React.ReactNode) => (
      <Box
        sx={{
          position: 'absolute',
          bottom: 10,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 2,
        }}
      >
        <ul style={{ margin: 0, padding: 0, display: 'flex', gap: 8 }}>{dots}</ul>
      </Box>
    ),
    customPaging: () => (
      <Box
        sx={{
          width: 12,
          height: 12,
          bgcolor: 'rgba(255,255,255,0.7)',
          borderRadius: '50%',
          border: '1px solid white',
        }}
      />
    ),
  };

  if (!user && profileId === "support") {
    history.push(HOME_PATH);
    return null;
  }

  const { Username, Verified, City, Birthday, UeberMich } = strangerUser || {};
  const verifiedIcon = Verified === 1 ? <Icon icon={faCheckCircle} style={{ color: '#42A5F5' }} /> : null;
  const locationText = strangerUser?.City ?? user?.City ?? 'Unbekannt';

  return (
    <>
      {!token && <PublicAppbarComponent />}
      <Box sx={{ px: isMobile ? 2 : 5, py: 3, maxWidth: isMobile ? '400px' : '1200px', mx: 'auto' }}>
        <Grid container spacing={4}>
          {/* GALLERY */}
          <Grid item xs={12} md={5}>
            <Box sx={{ position: 'relative', height: isMobile ? '60vh' : 500, borderRadius: 2, overflow: 'hidden' }}>
              <Slider {...settings}>
                {diashowPictures.map((img: any, i: number) => (
                  <Box key={i} sx={{ position: 'relative', width: '100%', height: '100%' }}>
                    <Box
                      sx={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        top: 0,
                        left: 0,
                        backgroundImage: `url(${generateValidUrl(img.Picture)})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        filter: 'blur(20px)',
                        zIndex: 1,
                      }}
                    />
                    <Box
                      component="img"
                      src={generateValidUrl(img.Picture)}
                      alt={`Profilbild ${i}`}
                      sx={{
                        position: 'relative',
                        zIndex: 2,
                        height: '100%',
                        width: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  </Box>
                ))}
              </Slider>
              {isMobile && (
                <IconButton
                  onClick={handleBack}
                  sx={{
                    position: 'absolute',
                    top: 10,
                    left: 10,
                    bgcolor: 'rgba(0,0,0,0.4)',
                  }}
                >
                  <Close sx={{ color: 'white' }} />
                </IconButton>
              )}
            </Box>
          </Grid>

          {/* PROFILE INFO */}
          <Grid item xs={12} md={7}>
            {isLoading ? (
              <ActivityIndicator />
            ) : (
              <>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  {Username} ({getAge(Birthday || '')}) {verifiedIcon}&nbsp;
                  {strangerUser?.IsOnline ? (
                    <Circle sx={{ color: '#19cea4', fontSize: '.8rem' }} />
                  ) : (
                    <Circle sx={{ color: 'red', fontSize: '.8rem' }} />
                  )}
                </Typography>

                <Typography variant="body2" sx={{ mt: 1, mb: 2 }}>
                  <Icon icon={faLocationArrow} /> {token ? locationText : <span style={{ filter: 'blur(6px)' }}>Registrier dich!</span>}
                </Typography>

                <Box sx={{ mb: 3 }}>
                  <Typography variant="h6" gutterBottom>Steckbrief</Typography>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2">{translation.TRAITS_RELATIONSHIP_TITLE}</Typography>
                      <Typography>{translation[BeziehungMap[strangerUser?.Relationship ?? 1] as keyof typeof translation]}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2">{translation.TRAITS_SIZE_TITLE}</Typography>
                      <Typography>{formatHeight(strangerUser?.Size ?? 179)}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2">{translation.TRAITS_EYECOLOR_TITLE}</Typography>
                      <Typography>{translation[AugenMap[strangerUser?.Eyes ?? 3] as keyof typeof translation]}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2">{translation.TRAITS_HAIRCOLOR_TITLE}</Typography>
                      <Typography>{translation[HaareMap[strangerUser?.Hair ?? 2] as keyof typeof translation]}</Typography>
                    </Grid>
                  </Grid>

                </Box>

                {UeberMich && (
                <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="h6" gutterBottom>Über mich</Typography>
                    <ChatBubbleOutlineIcon
                        onClick={handleOpenMessageDialog}
                        sx={{
                            backgroundColor: 'grey.400',
                            color: 'white',
                            fontSize: 30,
                            borderRadius: '50%',
                            padding: '6px',
                            cursor: 'pointer',
                            '&:hover': {
                            backgroundColor: 'grey.500'
                            }
                        }}
                    />
                    </Box>
                    <Typography>
                        {UeberMich}
                    </Typography>
                </Box>
                )}

                {strangerUser?.Interessen && (
                <Box sx={{ mb: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="h6" gutterBottom>Interessen</Typography>
                    <ChatBubbleOutlineIcon
                        onClick={handleOpenMessageDialog}
                        sx={{
                            backgroundColor: 'grey.400',
                            color: 'white',
                            fontSize: 30,
                            borderRadius: '50%',
                            padding: '6px',
                            cursor: 'pointer',
                            '&:hover': {
                            backgroundColor: 'grey.500'
                            }
                        }}
                    />
                    </Box>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {JSON.parse(strangerUser.Interessen).map((interesse: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined, index: React.Key | null | undefined) => (
                        <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            px: 2,
                            py: 0.5,
                            bgcolor: 'grey.200',
                            borderRadius: '999px',
                            fontSize: '0.9rem'
                        }}
                        >
                        {interesse}
                        </Box>
                    ))}
                    </Box>
                </Box>
                )}

                <Grid container spacing={2}>
                  <Grid item>
                    <LikeButton
                      profilId={strangerUser?.Profilid}
                      strangerUser={strangerUser}
                      token={token}
                      user={user}
                      variant="fab"
                      isLiked={strangerUser?.IsLiked ?? false}
                    />
                  </Grid>
                  <Grid item>
                    <MessageButton
                      strangerUser={strangerUser}
                      profilId={strangerUser?.Profilid}
                      username={Username}
                      token={token}
                      user={user}
                      variant="fab"
                    />
                  </Grid>
                  {!strangerUser?.AllreadyChattet && (
                    <Grid item>
                      <IceBreakerButton token={token} user={user} strangerUser={strangerUser} />
                    </Grid>
                  )}
                </Grid>
              </>
            )}
          </Grid>
        </Grid>

        {/* WEITERE BILDER – nun auch für Gäste & Mobil */}
        {(filteredPictures.length > 0) && (
          <Box sx={{ mt: 6 }}>
            <Typography variant="h6" gutterBottom>Bilder</Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
              {filteredPictures.map((pic: any, i: number) => (
                <StrangerPictureComponent
                  key={pic.Picture}
                  strangerPicture={pic.Picture}
                  coins={pic.Coins}
                  index={i}
                  onClick={handleClick}
                />
              ))}
            </Box>
          </Box>
        )}

        {/* GAST-CHAT */}
        {!user || !token ? (
          <Box sx={{ mt: 5 }} onClick={() => history.push(REGISTER_USER, { from: location.pathname })}>
            <ChatInput
              dialogId={strangerUser?.Profilid ?? ''}
              user={user}
              partnerId={strangerUser?.Profilid ?? ''}
              onSend={() => {}}
              userName={Username ?? ''}
            />
          </Box>
        ) : null}

        {/* GALERIE-DIALOG */}
        <StrangerImageGallery
          currentKey={currentKey}
          pictures={filteredPictures}
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          strangerUser={strangerUser}
          user={user}
          token={token}
          onPurchaseFinished={fetchProfile}
        />

        <NewMessageDialog
          open={messageDialogOpen}
          onClose={handleCloseMessageDialog}
          onSend={handleSendMessage}
          loading={messageLoading}
          defaultValue={UeberMich || ''}
        />
      </Box>
    </>
  );
});

export default StrangerProfilePage;
